import * as types from './types';

export default {
  state: {
    learnAfterTestRightResults: [],
  },
  getters: {
    [types.LEARN_AFTER_RIGHT_RESULTS]: state => state.learnAfterTestRightResults,
  },
  mutations: {
    [types.LEARN_AFTER_RIGHT_RESULTS]: (state, payload) => {
      state.learnAfterTestRightResults = payload.learnAfterTestRightResults;
    },
  },
};
